export enum FileStatus {
  Importing = 'importing',
  ImportFailed = 'import_failed',
  Starting = 'started',
  Processing = 'processing',
  Done = 'done',
  Failed = 'failed',
}

export enum BatchJobStatus {
  Started = 'started',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
  NotFound = 'not_found',
  Deleted = 'deleted',
}

export enum TerrainTileStatus {
  Started = 'started',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
  NotFound = 'not_found',
  Deleted = 'deleted',
}

export enum DSMStatus {
  Started = 'started',
  Processing = 'processing',
  Done = 'done',
  Failed = 'failed',
  NotFound = 'not_found',
  Deleted = 'deleted',
}

export enum FileFormat {
  MBTiles = 'mbtiles',
  GeoTIFF = 'geotiff',
  DXF = 'dxf',
  KML = 'kml',
  GPKG = 'gpkg',
  LAS = 'las',
  LAZ = 'laz',
  CSV = 'csv',
}

export enum FileExtension {
  MBTiles = '.mbtiles',
  CSV = '.csv',
  ZIP = '.zip',
  GeoTIFF = '.tif',
  TIFF = '.tiff',
  DXF = '.dxf',
  KML = '.kml',
  KMZ = '.kmz',
  GPKG = '.gpkg',
  LAS = '.las',
  LAZ = '.laz',
}

export enum UploadFilesErrorMessages {
  InvalidFileFormat = 'Invalid file format.',
  FileTooLarge = 'File too large. Please ensure the file size is under 2GB.',
  BlacklistedFileFormat = 'Unsupported file type. Executable files are not allowed for security reasons.'
}
